import React, { useEffect, useState } from "react";
import { apiFetch } from "./api";
import { formatData } from "../utils/expirare";

// ─────────────────────────────────────────────────────────────
//  v9.0: Solicitări de împuterniciri auto — pagină dedicată.
//  Folosește același sistem de tichete ca Solicitările (tip fix
//  „Împuternicire auto"), deci istoricul apare automat și în
//  LeaseinDAC, pe pagina /solicitari, alături de restul cererilor.
// ─────────────────────────────────────────────────────────────

export const TIP_IMPUTERNICIRE = "Împuternicire auto";

const STATUS_TEXT = { nou: "Nou", in_lucru: "În lucru", rezolvat: "Rezolvat" };

export default function Imputerniciri() {
  const [masini, setMasini] = useState([]);
  const [tichete, setTichete] = useState([]);

  const [masina, setMasina] = useState("");
  const [persoana, setPersoana] = useState("");
  const [dataStart, setDataStart] = useState("");
  const [dataStop, setDataStop] = useState("");
  const [scop, setScop] = useState("");
  const [status, setStatus] = useState("idle"); // idle | sending | success | error

  const incarcaIstoric = () => {
    apiFetch("/tichete")
      .then((d) => {
        const toate = d.tichete || [];
        setTichete(toate.filter((t) => t.tip === TIP_IMPUTERNICIRE));
      })
      .catch(() => {});
  };

  useEffect(() => {
    apiFetch("/masini").then((d) => setMasini(d.masini || [])).catch(() => {});
    incarcaIstoric();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("sending");
    // Compunem mesajul structurat — apare la fel și în LeaseinDAC.
    const parti = [`Persoană împuternicită: ${persoana.trim()}`];
    if (dataStart || dataStop) {
      parti.push(`Perioadă: ${dataStart || "?"} → ${dataStop || "?"}`);
    }
    if (scop.trim()) parti.push(`Scop / detalii: ${scop.trim()}`);
    try {
      const data = await apiFetch("/tichete", {
        method: "POST",
        body: JSON.stringify({
          tip: TIP_IMPUTERNICIRE,
          masina,
          mesaj: parti.join("\n"),
        }),
      });
      if (data && data.ok) {
        setStatus("success");
        setPersoana(""); setDataStart(""); setDataStop(""); setScop("");
        incarcaIstoric();
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  };

  return (
    <div className="solicitari">
      <div className="dash__head">
        <h1>Împuterniciri auto</h1>
        <p>
          Cere o împuternicire pentru una dintre mașinile flotei (de ex. pentru ieșirea din
          țară sau pentru un alt conducător auto). Echipa LEASEIN pregătește documentul și
          revine către tine.
        </p>
      </div>

      <div className="solicitari__grid">
        <div className="solicitari__form-wrap">
          <h2>Solicitare împuternicire</h2>
          {status === "success" ? (
            <div className="solicitari__success">
              <div className="solicitari__success-icon">
                <svg viewBox="0 0 24 24" width="30" height="30" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <h3>Solicitare trimisă!</h3>
              <p>Am primit cererea de împuternicire. Te contactăm în cel mai scurt timp.</p>
              <button className="btn btn--ghost" onClick={() => setStatus("idle")}>
                Trimite altă solicitare
              </button>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="solicitari__form">
              <label>
                Mașina
                <select value={masina} onChange={(e) => setMasina(e.target.value)} required>
                  <option value="">— alege mașina —</option>
                  {masini.map((m) => (
                    <option key={m.id} value={m.nrInmatriculare}>
                      {m.nrInmatriculare} — {m.model}
                    </option>
                  ))}
                </select>
              </label>
              <label>
                Persoana împuternicită (nume complet)
                <input
                  type="text"
                  value={persoana}
                  onChange={(e) => setPersoana(e.target.value)}
                  placeholder="ex: Ion Popescu"
                  required
                />
              </label>
              <div className="imput__perioada">
                <label>
                  De la
                  <input type="date" value={dataStart} onChange={(e) => setDataStart(e.target.value)} />
                </label>
                <label>
                  Până la
                  <input type="date" value={dataStop} onChange={(e) => setDataStop(e.target.value)} />
                </label>
              </div>
              <label>
                Scop / detalii (opțional)
                <textarea
                  rows="4"
                  value={scop}
                  onChange={(e) => setScop(e.target.value)}
                  placeholder="ex: Deplasare în Ungaria cu mașina, între datele de mai sus..."
                />
              </label>
              {status === "error" && (
                <small className="solicitari__error">
                  Ceva nu a mers. Încearcă din nou.
                </small>
              )}
              <button type="submit" className="btn btn--primary" disabled={status === "sending"}>
                {status === "sending" ? "Se trimite..." : "Trimite solicitarea"}
              </button>
            </form>
          )}
        </div>

        <div className="solicitari__istoric">
          <h2>Istoric împuterniciri</h2>
          {tichete.length === 0 ? (
            <div className="dash__empty">Nu ai cerut nicio împuternicire încă.</div>
          ) : (
            <ul className="tichete">
              {tichete.map((t) => (
                <li className="tichet" key={t.id}>
                  <div className="tichet__top">
                    <span className="tichet__tip">{t.vehicul_id || "Împuternicire"}</span>
                    <span className={`tichet__status tichet__status--${t.status}`}>
                      {STATUS_TEXT[t.status] || t.status}
                    </span>
                  </div>
                  <p className="tichet__mesaj tichet__mesaj--pre">{t.mesaj}</p>
                  <div className="tichet__meta">
                    <span>{formatData(t.creat_la)}</span>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}
